import React from "react";
import styles from "./DrawingTool.module.css";

type ColorsLegendProps = {
  colors: { [key: string]: string };
  treeWidth?: number;
};

export const ColorsLegend = (props: ColorsLegendProps) => (
  <div
    className={styles["colors-legend-box"]}
    style={{ left: `${(props.treeWidth ?? 350) + 20}px` }}
  >
    {Object.entries(props.colors).map(([name, color]) => (
      <div key={name} className={styles["colors-legend-row"]}>
        <div
          className={styles["colors-legend-circle"]}
          style={{ backgroundColor: color }}
        />
        <div className={styles["colors-legend-name"]}>{name}</div>
      </div>
    ))}
  </div>
);
